<template>
  <div class="categories-bar d-flex flex-column">
    <slot v-if="items.length" name="items">
      <CategoryItem
        v-for="item in items"
        :key="'cati_' + (item as any).text"
        :padding="itemPadding"
        :active="val == (item as any).value"
        :item="(item as any)"
        @select-item="onClickItem" />
    </slot>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import CategoryItem from './CategoryItem.vue';
import { mapMutations } from 'vuex';
import { mutations } from '@modules/libraries/store/types';
import { defineComponent } from 'vue';

interface DataType {
  val: number | string | boolean;
}

export default defineComponent({
  name: 'CategoryBar',
  components: {
    CategoryItem,
  },
  props: {
    category: {
      type: [Number, String, Boolean],
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemPadding: {
      type: String,
      default: '10px 24px',
    },
  },
  emits: ['change-category'],
  data: (): DataType => ({
    val: -1,
  }),
  watch: {
    category(newV, oldV) {
      if (newV === oldV) {
        return;
      }
      if (newV.length == 0) this.resetFetchedData();
      this.val = newV;
    },
  },
  created() {
    this.val = this.category;
  },
  methods: {
    ...mapMutations('library', {
      resetFetchedData: mutations.RESET_FETCHED_DATA,
    }),
    onClickItem(item: any) {
      this.val = item.value;
      this.$emit('change-category', item.value);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.categories-bar {
  background: $light1;
  max-width: 228px;
  border-right: 1px solid rgba($neutral_3, 0.1);
}

// eslint-disable-next-line vue-scoped-css/no-unused-selector
.action-item {
  border-top: 1px solid $light3;
  color: $text-light-low;
  @include flex-center;
  @include trans-all;

  &:not(:disabled):not(.disabled):hover {
    background: $light2;
    color: $text-light-high;
    cursor: pointer;
  }

  &.active,
  &:active {
    background: rgba($mono3, 0.1) !important;
    color: $mono3 !important;
  }
}
</style>
